import { Modal, ModalVariant } from '@ben/orion/modals';
import { ButtonVariant } from '@ben/orion/deprecated-button';
import { IconName } from '@ben/orion/icon';
import type { FC } from 'react';
import { memo } from 'react';
interface IFallbackConfirmationModal {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
}

const FallbackConfirmationModal: FC<IFallbackConfirmationModal> = ({
  isOpen,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title="Are you sure you want to make this a fallback table?"
      onConfirm={onConfirm}
      onClose={onClose}
      description="You already have one or more fallback tables for this benefit."
      icon={IconName.Alert}
      variant={ModalVariant.Icon}
      primaryText="Change fallback table"
      secondaryText="Cancel"
      primaryVariant={ButtonVariant.error}
    />
  );
};

export default memo(FallbackConfirmationModal);
